import ButtonQuestion from './ButtonQuestion';
import AppContext from '../contexts/AppContext';
import EnphaseContext from '../contexts/EnphaseContext';
import { useContext, useEffect } from 'react';
import icons from '../data/iconsBillButtons';

export default function BillButtons() {
  const { getInitialEnphaseData } = useContext(EnphaseContext);
  const {
    slides,
    currentSlide,
    geoData,
    updateSelectedOption,
    getSlideIndex,
  } = useContext(AppContext);

  const options = slides.find(
    (slide: any) => slide.key === 'billButtons'
  ).options;

  useEffect(() => {
    const addressSlideNumber = getSlideIndex('addressOwnership');

    if (
      geoData?.zip &&
      !slides[addressSlideNumber].additionalFields?.selectedZipCode
    ) {
      updateSelectedOption(
        slides[addressSlideNumber].key,
        geoData.zip || '',
        'selectedZipCode'
      );
    }

    getInitialEnphaseData();
  }, []);

  return (
    <div className="mt-[30px] md:mt-[60px] flex justify-between flex-col md:flex-row">
      {options.map((option: any, index: number) => {
        const className = index !== options.length - 1 ? 'mb-4 md:mb-0' : '';
        const { path } = icons.find((icon) => icon.name === option.icon) || {};
        const { path: hoverPath } =
          icons.find((icon) => icon.name === option.iconHover) || {};

        return (
          <ButtonQuestion
            className={className}
            key={index}
            name={option.name}
            icon={path}
            iconHover={hoverPath}
            isTextIcon={true}
            value={option.value}
            optionKey="billButtons"
            selected={
              slides[currentSlide].selectedValue === option.value
            }></ButtonQuestion>
        );
      })}
    </div>
  );
}
